import React, { useEffect, useState } from 'react'
import { Routes,Route,} from "react-router-dom";


const Ds = () => {
  document.title = 'Winter is coming';


  return (
  <div className="container">
    <h1>Winter arrives quietly, covering the world in a soft white blanket. The air turns crisp, and every breath feels fresh and sharp, as though nature itself has paused to rest. Trees stand bare, their branches etched against the pale sky, while snow sparkles under the weak sunlight like scattered diamonds. Streets grow quieter, as if muffled by the snow, and the world feels calmer, slower, more peaceful. Winter is not just cold and silence, though. It brings joy in simple things—children laughing as they build snowmen, the warmth of hot cocoa after a walk in the frost, and the comfort of gathering with family near a glowing fire. The season teaches us to appreciate stillness, to find beauty in simplicity, and to enjoy warmth all the more because of the cold. Though some may see winter only as harsh and bleak, it holds its own kind of magic. It is the season of rest, reflection, and renewal, preparing the earth—and us—for the lively spring to come.</h1>
  </div>
  )

}

export default Ds;
